import { render, staticRenderFns } from "./MultipleQuotation.vue?vue&type=template&id=2079bc76&scoped=true"
import script from "./MultipleQuotation.vue?vue&type=script&lang=js"
export * from "./MultipleQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079bc76",
  null
  
)

export default component.exports